import AppState from '../../types/app-state'
// import {Role} from '../../../values/Role'

export const currentFilterStateSelector = (state: AppState): boolean => state.CHRFilter.onlyUserCHR
